import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Wie erhalte ich das Material?',
  a: 'Sofort nach dem Kauf per E-Mail als Download-Link. PDF-Format für jedes Gerät. Kein Warten.'
}, {
  q: 'Sind die Field Cards laminierbar?',
  a: 'Ja. Ausdrucken, laminieren, auf die Piste. Wasserdicht und professionell.'
}, {
  q: 'Wie lange habe ich Zugang?',
  a: 'Lebenslanger Zugang inklusive aller zukünftigen Updates kostenlos.'
}, {
  q: 'Wie funktioniert die Garantie?',
  a: '7 Tage. Nicht zufrieden — volle Rückerstattung. Ohne Fragen.'
}, {
  q: 'Welche Zahlungsmethoden werden akzeptiert?',
  a: 'Kreditkarte, PayPal und Twint. SSL-verschlüsselt und 100% sicher.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-surface border-t border-brand-border" data-id="element-62">
      <div className="max-w-xl mx-auto" data-id="element-63">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-center mb-8 text-brand-navy" data-id="element-64">
          Häufig gestellte Fragen
        </motion.h2>

        <div className="space-y-3" data-id="element-65">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-white border border-brand-border rounded-xl overflow-hidden shadow-sm" data-id="element-66">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors gap-3" data-id="element-67">
                <span className="font-bold text-brand-navy text-sm sm:text-base" data-id="element-68">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-69" />
              </button>

              <AnimatePresence data-id="element-70">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-71">
                    <div className="px-5 pb-4 pt-0 text-sm text-brand-muted font-medium leading-relaxed" data-id="element-72">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}